// portals/shared/src/MuiThemeProvider.jsx
import React from "react";
import { ThemeProvider, CssBaseline, createTheme } from "@mui/material";
import { getBaseTheme } from "./muiTheme";

export default function MuiThemeProvider({ brand = "user", mode = "light", overrides, children }) {
  const theme = React.useMemo(() => {
    const base = getBaseTheme({ brand, mode });
    return overrides ? createTheme(base, overrides) : base; // createTheme merges
  }, [brand, mode, overrides]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
